module.exports = __webpack_public_path__ + "img/CR.1e960611.png";